import { Link } from '@tanstack/react-router'

import { useMyPurchases } from '@lb/domain'
import { useTranslation } from '@lb/i18n'
import { Button } from '@lb/ui'

import { http } from '../../lib/client'
import { useSessionContext } from '../providers/session'

/**
 * « Accès · Achat à l'unité » — the rail card a single-purchase member gets.
 *
 * The design puts it at the foot of the sidebar, above the profile pill, and
 * it answers the question a locked nav raises: *why is half of this greyed
 * out?* One line of standing, a count of what they own, and the way in.
 *
 * Nothing for a subscriber and nothing for somebody who owns nothing — the
 * card exists to explain a mixed state, and there is no mixed state without a
 * purchase. The read is the same query the Home strip uses, so this costs no
 * extra request.
 */
export function AccessCard() {
  const { t } = useTranslation()
  const { viewer } = useSessionContext()
  const purchases = useMyPurchases(http, viewer?.entitlement !== 'entitled')

  const items = purchases.data?.items ?? []
  if (items.length === 0) return null

  const courses = items.filter((item) => item.contentType === 'COURSE').length
  const tickets = items.length - courses

  return (
    <div className="mt-6 rounded-[var(--r-md)] border border-border bg-cream-dark p-3">
      <p className="text-[10px] font-bold uppercase tracking-[0.1em] text-muted">
        {t('surface.accessEyebrow')}
      </p>
      <p className="mt-1 text-[13px] font-semibold text-ink">{t('surface.singlePurchase')}</p>
      <p className="mt-0.5 text-[12px] text-muted">
        {[
          courses > 0 ? t('surface.courseCount', { count: courses }) : null,
          tickets > 0 ? t('surface.ticketCount', { count: tickets }) : null,
          t('surface.noSubscription'),
        ]
          .filter(Boolean)
          .join(' · ')}
      </p>
      <Button asChild size="sm" className="mt-2.5 w-full">
        <Link to="/plans">{t('surface.becomeMember')}</Link>
      </Button>
    </div>
  )
}
